const isValidCallbackText = ({ block }: any) => {
    const {
        data: { text },
    } = block;
    return {
        isValid: Boolean(text.trim()),
        error: (
            // <Alert
            //     message="Validation Error"
            //     description={`Text cannot be empty`}
            //     type="error"
            //     showIcon
            // />
            <></>
        ),
    };
};

export default isValidCallbackText;
